module.exports = __webpack_public_path__ + "img/ico-satelite-s.33cac1d7.svg";